import React, { useEffect, useRef } from 'react';
import * as S from './styles';
import { ImageInCarrosselScreens } from 'types/ImageInCarrosselScreens';

type CarouselImgCampaignProps = {
	imgs: ImageInCarrosselScreens[];
};

export default function CarouselImgCampaign({
	imgs
}: CarouselImgCampaignProps) {
	const listRef = useRef<HTMLDivElement>(null);
	const scrollSpeed = 1; // Ajuste a velocidade do scroll aqui

	//passa automaticamente para o lado o carrossel
	useEffect(() => {
		const list = listRef.current;
		if (!list) return;

		let scrollInterval: NodeJS.Timeout | null = null;

		const startScrolling = () => {
			if (scrollInterval) return;

			scrollInterval = setInterval(() => {
				if (list.scrollLeft + list.clientWidth >= list.scrollWidth) {
					list.scrollLeft = 0; // Reinicia o scroll quando chega ao final
				} else {
					list.scrollLeft += scrollSpeed;
				}
			}, 35);
		};

		const stopScrolling = () => {
			if (scrollInterval) {
				clearInterval(scrollInterval);
				scrollInterval = null;
			}
		};

		startScrolling();

		list.addEventListener('mouseenter', stopScrolling);
		list.addEventListener('mouseleave', startScrolling);

		return () => {
			stopScrolling();
			list.removeEventListener('mouseenter', stopScrolling);
			list.removeEventListener('mouseleave', startScrolling);
		};
	}, []);

	return (
		<S.container ref={listRef}>
			{imgs.map((img) => (
				<S.img key={img.id}>
					<img src={img.urlImage} />
					{img.labelImage !== '' && (
						<S.text>
							<p>{img.labelImage}</p>
						</S.text>
					)}
				</S.img>
			))}
		</S.container>
	);
}
